// extracted by mini-css-extract-plugin
export default {"button":"amount-button_button__XFXUU"};